import axios from 'axios';
import { AppUrls, } from './Globals';
import { Config } from './Config';

export const creditRequests = {}

creditRequests.GetNewCreditOption = (data) => {
  return axios.post(
    AppUrls.GetNewCreditOption,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.AsignateNewCreditOption = (data) => {
  return axios.post(
    AppUrls.AsignateNewCreditOption,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.GetCobranzaPagos = (data) => {
  return axios.post(
    AppUrls.GetCobranzaPagos,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.GenerarDatosCobranzaUnico = (data) => {
  return axios.post(
    AppUrls.GenerarDatosCobranzaUnico,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.GetCobranzaCobro = (data) => {
  return axios.post(
    AppUrls.GetCobranzaCobro,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.GetUserGoal = (data) => {
  return axios.post(
    AppUrls.GetUserGoal,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.RegisterUserGoal = (data) => {
  return axios.post(
    AppUrls.RegisterUserGoal,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.GetDependencies = (data) => {
  return axios.post(
    AppUrls.GetDependencies,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

creditRequests.GetCalculateDataFile = (data) => {
  return axios.post(
    AppUrls.GetCalculateDataFile,
    Config.SetParameters(data, '', '', ''),
    Config.ConfigAuth()
  ).then(handleResponse)
}

let handleResponse = (response) => {
  let respObject = response.data;//BodySecurityResponse(response.data);
  if (!respObject.IsOK) {
    let responseObject = { message: respObject.Messages + ' ' + (respObject.TansactionId ? respObject.TansactionId : '') + ' ' + (respObject.statusText ? respObject.statusText : '') };
    let error = (respObject.Body || responseObject);
    return Promise.reject(error);
  }
  return respObject;
}